import React, { useState } from "react";
import glassesList from "./dataGlasses.json";

export default function GlassesTryingOn() {
  const [currentGlass, setCurrentGlass] = useState({});

  const changeGlass = (glass) => setCurrentGlass({ ...glass });

  return (
    <div className="container">
      <div className="d-flex justify-content-around">
        <div className="model" style={{ width: "440px" }}>
          <div className="cover" style={{ position: "relative" }}>
            <img
              src="https://i.pinimg.com/originals/c0/37/26/c0372607967782567f467018363894e2.jpg"
              alt="v1"
              style={{ width: "100%" }}
            />
            {currentGlass.url && (
              <img
                src={currentGlass.url}
                alt=""
                className="glass"
                style={{
                  position: "absolute",
                  width: "245px",
                  left: "50%",
                  top: "29%",
                  transform: "translate(-50%)",
                }}
              />
            )}
            <div
              className="overlay"
              style={{
                position: "absolute",
                bottom: 0,
                backgroundColor: "#fbc56167",
              }}
            >
              <h4 style={{ color: "purple" }}>{currentGlass.name}</h4>
              <p style={{ color: "white" }}>{currentGlass.desc}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        {glassesList.map((glass) => (
          <div
            key={glass.id}
            className="glass-imgs"
            style={{ border: "1px solid #333", cursor: "pointer" }}
            onClick={() => changeGlass(glass)}
          >
            <div className="glasses">
              <img src={glass.url} alt="glass" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
